import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useRouterActions } from 'react-resource-router';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useFlags } from '@atlaskit/flag';
import { LoadingSpinner } from '@atlassian/proforma-common-core/jira-common';
import { MediaProvider } from '@atlassian/proforma-common-core/jira-common-context';
import { Footer } from '../../common/ui/footer';
import { FormValidationMessage } from '../../common/ui/form-validation-message';
import { FormWithName } from '../../common/ui/form-with-name';
import { IssueFormsBody, IssueFormsBodyWrapper, IssueFormsContent } from '../../common/ui/styles';
import { getFormValidationResultMessage } from '../../common/utils/process-form-load-error';
import { useFormStoreController } from '../../controllers/form-store';
import { useAttachmentService } from '../../services/attachments';
import { useFormService } from '../../services/form';
import { IssueCreatedEmbedded } from './embed';
export const IssueFormsDirect = ({
  formDetails,
  project,
  userIsProjectAdmin,
  reporterAccountId,
  isEmbed
}) => {
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const {
    showFlag
  } = useFlags();
  const [{
    data: mediaApiUploadToken
  }, {
    loadMediaApiUploadToken
  }] = useAttachmentService();
  const [{
    data: form,
    error: formLoadError,
    loading: formLoading
  }, {
    load: loadForm
  }] = useFormService();
  const [{
    formStore
  }, {
    clear: clearFormStore,
    create: createFormStore
  }] = useFormStoreController(reporterAccountId);
  const intl = useIntl();
  const {
    push
  } = useRouterActions();
  const [formValidationResultMessage, setFormValidationResultMessage] = useState();
  const [lastCreatedIssueKey, setLastCreatedIssueKey] = useState();
  useEffect(() => {
    loadMediaApiUploadToken(formDetails.projectId);
  }, [formDetails === null || formDetails === void 0 ? void 0 : formDetails.projectId, loadMediaApiUploadToken]);
  useEffect(() => {
    loadForm(formDetails);
  }, [formDetails, loadForm]);
  useEffect(() => {
    if (form) {
      createFormStore(formDetails, form);
    } else {
      clearFormStore();
    }
  }, [clearFormStore, createFormStore, form, formDetails]);
  useEffect(() => {
    if (formLoadError) {
      const newFormValidationResultMessage = getFormValidationResultMessage(formLoadError, project, formDetails, intl, push, showFlag, createAnalyticsEvent, userIsProjectAdmin);
      if (newFormValidationResultMessage) {
        setFormValidationResultMessage(newFormValidationResultMessage);
      }
    }
    // NOTE: `intl` from `useIntl()` must not be used in a dependency list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAnalyticsEvent, formDetails, formLoadError, project, push, showFlag, userIsProjectAdmin]);
  const mediaContext = {
    mediaApiUploadToken,
    projectId: formDetails === null || formDetails === void 0 ? void 0 : formDetails.projectId
  };
  return /*#__PURE__*/React.createElement(MediaProvider, {
    mediaContext: mediaContext
  }, /*#__PURE__*/React.createElement(IssueFormsContent, null, isEmbed && lastCreatedIssueKey ? /*#__PURE__*/React.createElement(IssueCreatedEmbedded, {
    issueKey: lastCreatedIssueKey,
    onCreateClick: () => setLastCreatedIssueKey(undefined)
  }) : formLoading ? /*#__PURE__*/React.createElement(IssueFormsBodyWrapper, null, /*#__PURE__*/React.createElement(IssueFormsBody, null, /*#__PURE__*/React.createElement(LoadingSpinner, null))) : formValidationResultMessage ? /*#__PURE__*/React.createElement(IssueFormsBodyWrapper, null, /*#__PURE__*/React.createElement(IssueFormsBody, null, /*#__PURE__*/React.createElement(FormValidationMessage, {
    formValidationResultMessage: formValidationResultMessage
  }))) : formStore ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IssueFormsBodyWrapper, null, /*#__PURE__*/React.createElement(IssueFormsBody, null, /*#__PURE__*/React.createElement(FormWithName, {
    formStore: formStore
  }))), /*#__PURE__*/React.createElement(Footer, {
    formDetails: formDetails,
    formStore: formStore,
    project: project,
    userIsProjectAdmin: userIsProjectAdmin,
    onIssueCreated: isEmbed ? setLastCreatedIssueKey : undefined
  })) : /*#__PURE__*/React.createElement(React.Fragment, null)));
};